export var SearchReportMutationTypes;
(function (SearchReportMutationTypes) {
    SearchReportMutationTypes["INIT_STATE"] = "INIT_STATE";
    SearchReportMutationTypes["SET_SORT_TYPE"] = "SET_SORT_TYPE";
    SearchReportMutationTypes["SET_SEARCH_FORM"] = "SET_SEARCH_FORM";
    SearchReportMutationTypes["RESET_LIST"] = "RESET_LIST";
    SearchReportMutationTypes["SEARCH_REPROTS"] = "SEARCH_REPROTS";
})(SearchReportMutationTypes || (SearchReportMutationTypes = {}));
